<template>
  <div class="selector">
    <ul class="selector__tabs">
      <li
        class="selector__tabs__item"
        v-for="area in data.areas"
        :key="area.id"
      >
        <button
          :class="area.id === selectedArea.id && 'is-current'"
          @click="changeArea(area)"
        >
          <span>
            <ThumbAreaShirts :name="area.slug" :current="area.id === selectedArea.id" />
          </span>
          {{ area.name }}
        </button>
      </li>
    </ul>
    <ul class="selector__subTabs">
      <li
        class="selector__subTabs__item"
        v-for="part in currentParts"
        :key="part.id"
      >
        <button
          :class="`${ isPartSelected(part) && 'is-selected' }`"
          @click="handleChangePart(part)"
        >
          <span>
            <ThumbPartShirts :name="part.slug" :current="isPartSelected(part)" />
          </span>
          {{ part.name }}
        </button>
      </li>
    </ul>
    <div class="selector__wrapper">
      <div class="selector__container">
        <!-- 全体 -->
        <template v-if="selectedArea.slug === 'overall'">
          <div class="items items--shirtsItems">
            <div class="items__item" v-for="item in overAllItems" :key="item.id">
              <button
                @click="changeOverallItem(item)"
                :class="`items__button ${ item.id === selectedOverallItem.id && 'is-selected' }`"
              >
                <span class="items__thumb">
                  <ShirtsFrontOverallItemImage
                    :type="item.slug"
                    name="selector"
                  />
                  <img src="/simulator/images/texture/s-all-base-ptn-103-front.svg" alt="" v-if="item.slug === 'pattern'">
                </span>
                {{ item.name }}
              </button>
            </div>
          </div>
          <div v-if="selectedOverallItem.slug === 'single_color'" class="items items--colors">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ selectedOverallItemSingleColor === 'transparent' && 'is-selected' }`"
                @click="changeOverallItemSingleColor('transparent')"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="color in colors" :key="color">
              <button
                :style="{ backgroundColor: color }"
                :class="`items__button ${ selectedOverallItemSingleColor === color && 'is-selected' }`"
                @click="changeOverallItemSingleColor(color)"
              >
              </button>
            </div>
          </div>
          <div v-if="selectedOverallItem.slug === 'gradation'" class="items items--colors">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ selectedOverallItemGradationStartColor === 'transparent' && 'is-selected' }`"
                @click="changeOverallItemGradationStartColor('transparent')"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="color in colors" :key="color">
              <button
                :style="{ backgroundColor: color }"
                :class="`items__button ${ selectedOverallItemGradationStartColor === color && 'is-selected' }`"
                @click="changeOverallItemGradationStartColor(color)"
              >
              </button>
            </div>
          </div>
          <div v-if="selectedOverallItem.slug === 'gradation'" class="items items--colors">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ selectedOverallItemGradationEndColor === 'transparent' && 'is-selected' }`"
                @click="changeOverallItemGradationEndColor('transparent')"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="color in colors" :key="color">
              <button
                :style="{ backgroundColor: color }"
                :class="`items__button ${ selectedOverallItemGradationEndColor === color && 'is-selected' }`"
                @click="changeOverallItemGradationEndColor(color)"
              >
              </button>
            </div>
          </div>
          <div v-if="selectedOverallItem.slug === 'stripe'" class="items items--colors">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ selectedOverallItemStripeColor === 'transparent' && 'is-selected' }`"
                @click="changeOverallItemStripeColor('transparent')"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="color in colors" :key="color">
              <button
                :style="{ backgroundColor: color }"
                :class="`items__button ${ selectedOverallItemStripeColor === color && 'is-selected' }`"
                @click="changeOverallItemStripeColor(color)"
              >
              </button>
            </div>
          </div>
          <div class="items items--textures" v-if="selectedOverallItem.slug === 'pattern'">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ selectedOverallItemTexture === null && 'is-selected' }`"
                @click="changeOverallItemTexture(null)"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="texture in textures" :key="texture.icon">
              <button
                :class="`items__button ${ selectedOverallItemTexture === texture && 'is-selected' }`"
                @click="changeOverallItemTexture(texture)"
              >
                <img :src="`${ texture }-ico.svg`" alt="">
              </button>
            </div>
          </div>
        </template>
        <!-- 胴 -->
        <template v-else-if="selectedArea.slug === 'body'">
          <!-- 胴 -->
          <template v-if="isContainPartSlug('body_main')">
            <div class="items items--shirtsItems">
              <div class="items__item" v-for="item in bodyMainItems" :key="item.id">
                <button
                  @click="changeBodyMainItem(item)"
                  :class="`items__button ${ item.id === selectedBodyMainItem.id && 'is-selected' }`"
                >
                  <span class="items__thumb">
                    <ThumbElementShirtsBodyMain :name="item.slug" />
                  </span>
                  {{ item.name }}
                </button>
              </div>
            </div>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedBodyMainItemColor === 'transparent' && 'is-selected' }`"
                  @click="changeBodyMainItemColor('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedBodyMainItemColor === color && 'is-selected' }`"
                  @click="changeBodyMainItemColor(color)"
                >
                </button>
              </div>
            </div>
            <div class="items items--textures">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedBodyMainItemTexture === null && 'is-selected' }`"
                  @click="changeBodyMainItemTexture(null)"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="texture in textures" :key="texture.icon">
                <button
                  :class="`items__button ${ selectedBodyMainItemTexture === texture && 'is-selected' }`"
                  @click="changeBodyMainItemTexture(texture)"
                >
                  <img :src="`${ texture }-ico.svg`" alt="">
                </button>
              </div>
            </div>
          </template>
          <!-- 脇 -->
          <template v-else-if="isContainPartSlug('body_side')">
            <div class="items items--shirtsItems">
              <div class="items__item" v-for="item in bodySideItems" :key="item.id">
                <button
                  @click="changeBodySideItem(item)"
                  :class="`items__button ${ item.id === selectedBodySideItem.id && 'is-selected' }`"
                >
                  <span class="items__thumb">
                    <ThumbElementShirtsBodySide :name="item.slug" />
                  </span>
                  {{ item.name }}
                </button>
              </div>
            </div>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedBodySideItemColor === 'transparent' && 'is-selected' }`"
                  @click="changeBodySideItemColor('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedBodySideItemColor === color && 'is-selected' }`"
                  @click="changeBodySideItemColor(color)"
                >
                </button>
              </div>
            </div>
            <div v-show="selectedBodySideItem.number_of_colors >= 2" class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedBodySideItemColor2 === 'transparent' && 'is-selected' }`"
                  @click="changeBodySideItemColor2('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedBodySideItemColor2 === color && 'is-selected' }`"
                  @click="changeBodySideItemColor2(color)"
                >
                </button>
              </div>
            </div>
            <div class="items items--textures">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedBodySideItemTexture === null && 'is-selected' }`"
                  @click="changeBodySideItemTexture(null)"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="texture in textures" :key="texture.icon">
                <button
                  :class="`items__button ${ selectedBodySideItemTexture === texture && 'is-selected' }`"
                  @click="changeBodySideItemTexture(texture)"
                >
                  <img :src="`${ texture }-ico.svg`" alt="">
                </button>
              </div>
            </div>
          </template>
        </template>
        <!-- 襟ライン -->
        <template v-else-if="selectedArea.slug === 'collar'">
          <div class="items items--shirtsItems">
            <div class="items__item" v-for="item in collarItems" :key="item.id">
              <button
                @click="changeCollarItem(item)"
                :class="`items__button ${ item.id === selectedCollarItem.id && 'is-selected' }`"
              >
                <span class="items__thumb">
                  <ThumbElementShirtsCollar :name="item.slug" />
                </span>
                {{ item.name }}
              </button>
            </div>
          </div>
          <div class="items items--colors">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ selectedCollarItemColor === 'transparent' && 'is-selected' }`"
                @click="changeCollarItemColor('transparent')"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="color in colors" :key="color">
              <button
                :style="{ backgroundColor: color }"
                :class="`items__button ${ selectedCollarItemColor === color && 'is-selected' }`"
                @click="changeCollarItemColor(color)"
              >
              </button>
            </div>
          </div>
          <div v-show="selectedCollarItem.number_of_colors >= 2" class="items items--colors">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ selectedCollarItemColor2 === 'transparent' && 'is-selected' }`"
                @click="changeCollarItemColor2('transparent')"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="color in colors" :key="color">
              <button
                :style="{ backgroundColor: color }"
                :class="`items__button ${ selectedCollarItemColor2 === color && 'is-selected' }`"
                @click="changeCollarItemColor2(color)"
              >
              </button>
            </div>
          </div>
          <div v-show="selectedCollarItem.number_of_colors >= 3" class="items items--colors">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ selectedCollarItemColor3 === 'transparent' && 'is-selected' }`"
                @click="changeCollarItemColor3('transparent')"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="color in colors" :key="color">
              <button
                :style="{ backgroundColor: color }"
                :class="`items__button ${ selectedCollarItemColor3 === color && 'is-selected' }`"
                @click="changeCollarItemColor3(color)"
              >
              </button>
            </div>
          </div>
        </template>
        <!-- 腕 -->
        <template v-else-if="selectedArea.slug === 'arm'">
          <!-- 肩パーツ -->
          <template v-if="isContainPartSlug('arm_shoulder_part')">
            <div class="items items--shirtsItems">
              <div class="items__item" v-for="item in armShoulderPartItems" :key="item.id">
                <button
                  @click="changeArmShoulderPartItem(item)"
                  :class="`items__button ${ item.id === selectedArmShoulderPartItem.id && 'is-selected' }`"
                >
                  <span class="items__thumb">
                    <ShirtsArmShoulderPartItemImage :name="item.slug" />
                  </span>
                  {{ item.name }}
                </button>
              </div>
            </div>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedArmShoulderPartItemColor === 'transparent' && 'is-selected' }`"
                  @click="changeArmShoulderPartItemColor('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedArmShoulderPartItemColor === color && 'is-selected' }`"
                  @click="changeArmShoulderPartItemColor(color)"
                >
                </button>
              </div>
            </div>
          </template>
          <!-- 腕パーツ -->
          <template v-else-if="isContainPartSlug('arm_arm_part')">
            <div class="items items--shirtsItems">
              <div class="items__item" v-for="item in armArmPartItems" :key="item.id">
                <button
                  @click="changeArmArmPartItem(item)"
                  :class="`items__button ${ item.id === selectedArmArmPartItem.id && 'is-selected' }`"
                >
                  <span class="items__thumb">
                    <ShirtsArmArmPartItemImage :name="item.slug" />
                  </span>
                  {{ item.name }}
                </button>
              </div>
            </div>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedArmArmPartItemColor === 'transparent' && 'is-selected' }`"
                  @click="changeArmArmPartItemColor('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedArmArmPartItemColor === color && 'is-selected' }`"
                  @click="changeArmArmPartItemColor(color)"
                >
                </button>
              </div>
            </div>
            <div v-show="selectedArmArmPartItem.number_of_colors >= 2" class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedArmArmPartItemColor2 === 'transparent' && 'is-selected' }`"
                  @click="changeArmArmPartItemColor2('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedArmArmPartItemColor2 === color && 'is-selected' }`"
                  @click="changeArmArmPartItemColor2(color)"
                >
                </button>
              </div>
            </div>
          </template>
          <!-- 袖パーツ -->
          <template v-else-if="isContainPartSlug('arm_sleeve_part')">
            <div class="items items--shirtsItems">
              <div class="items__item" v-for="item in armSleevePartItems" :key="item.id">
                <button
                  @click="changeArmSleevePartItem(item)"
                  :class="`items__button ${ item.id === selectedArmSleevePartItem.id && 'is-selected' }`"
                >
                  <span class="items__thumb">
                    <ShirtsArmSleevePartItemImage :name="item.slug" />
                  </span>
                  {{ item.name }}
                </button>
              </div>
            </div>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedArmSleevePartItemColor === 'transparent' && 'is-selected' }`"
                  @click="changeArmSleevePartItemColor('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedArmSleevePartItemColor === color && 'is-selected' }`"
                  @click="changeArmSleevePartItemColor(color)"
                >
                </button>
              </div>
            </div>
            <div v-show="selectedArmSleevePartItem.number_of_colors >= 2" class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedArmSleevePartItemColor2 === 'transparent' && 'is-selected' }`"
                  @click="changeArmSleevePartItemColor2('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedArmSleevePartItemColor2 === color && 'is-selected' }`"
                  @click="changeArmSleevePartItemColor2(color)"
                >
                </button>
              </div>
            </div>
          </template>
          <!-- 袖ライン -->
          <template v-else-if="isContainPartSlug('arm_sleeve_line')">
            <div class="items items--shirtsItems">
              <div class="items__item" v-for="item in armSleeveLineItems" :key="item.id">
                <button
                  @click="changeArmSleeveLineItem(item)"
                  :class="`items__button ${ item.id === selectedArmSleeveLineItem.id && 'is-selected' }`"
                >
                  <span class="items__thumb">
                    <ShirtsArmSleeveLineItemImage :name="item.slug" />
                  </span>
                  {{ item.name }}
                </button>
              </div>
            </div>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedArmSleeveLineItemColor === 'transparent' && 'is-selected' }`"
                  @click="changeArmSleeveLineItemColor('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedArmSleeveLineItemColor === color && 'is-selected' }`"
                  @click="changeArmSleeveLineItemColor(color)"
                >
                </button>
              </div>
            </div>
            <div v-show="selectedArmSleeveLineItem.number_of_colors >= 2" class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedArmSleeveLineItemColor2 === 'transparent' && 'is-selected' }`"
                  @click="changeArmSleeveLineItemColor2('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedArmSleeveLineItemColor2 === color && 'is-selected' }`"
                  @click="changeArmSleeveLineItemColor2(color)"
                >
                </button>
              </div>
            </div>
            <div v-show="selectedArmSleeveLineItem.number_of_colors >= 3" class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedArmSleeveLineItemColor3 === 'transparent' && 'is-selected' }`"
                  @click="changeArmSleeveLineItemColor3('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedArmSleeveLineItemColor3 === color && 'is-selected' }`"
                  @click="changeArmSleeveLineItemColor3(color)"
                >
                </button>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ThumbAreaShirts from '../images/thumb/area/shirts/ThumbAreaShirts'                             // シャツのエリア画像
import ThumbPartShirts from '../images/thumb/part/shirts/ThumbPartShirts'                             // シャツのエリア画像
import ShirtsFrontOverallItemImage from '../images/item/ShirtsFrontOverallItemImage'
import ThumbElementShirtsBodyMain from '../images/thumb/element/shirts/ThumbElementShirtsBodyMain'    // シャツ「胴 - 胴」
import ThumbElementShirtsBodySide from '../images/thumb/element/shirts/ThumbElementShirtsBodySide'    // シャツ「胴 - 脇」
import ThumbElementShirtsCollar from '../images/thumb/element/shirts/ThumbElementShirtsCollar'
import ShirtsArmShoulderPartItemImage from '../images/item/ShirtsArmShoulderPartItemImage'
import ShirtsArmArmPartItemImage from '../images/item/ShirtsArmArmPartItemImage'
import ShirtsArmSleevePartItemImage from '../images/item/ShirtsArmSleevePartItemImage'
import ShirtsArmSleeveLineItemImage from '../images/item/ShirtsArmSleeveLineItemImage'
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
    ThumbAreaShirts,
    ThumbPartShirts,
    ShirtsFrontOverallItemImage,
    ThumbElementShirtsBodyMain,
    ThumbElementShirtsBodySide,
    ThumbElementShirtsCollar,
    ShirtsArmShoulderPartItemImage,
    ShirtsArmArmPartItemImage,
    ShirtsArmSleevePartItemImage,
    ShirtsArmSleeveLineItemImage,
  },
  computed: {
    ...mapState({
      data: state => state.shirts.data,
      colors: state => state.shirts.colors,
      textures: state => state.shirts.textures,
      selectedArea: state => state.shirts.selectedArea,
      selectedPart: state => state.shirts.selectedPart,
      selectedOverallItem: state => state.shirts.selectedOverallItem,
      selectedOverallItemSingleColor: state => state.shirts.selectedOverallItemSingleColor,
      selectedOverallItemGradationStartColor: state => state.shirts.selectedOverallItemGradationStartColor,
      selectedOverallItemGradationEndColor: state => state.shirts.selectedOverallItemGradationEndColor,
      selectedOverallItemStripeColor: state => state.shirts.selectedOverallItemStripeColor,
      selectedOverallItemTexture: state => state.shirts.selectedOverallItemTexture,
      selectedBodyMainItem: state => state.shirts.selectedBodyMainItem,
      selectedBodyMainItemColor: state => state.shirts.selectedBodyMainItemColor,
      selectedBodyMainItemTexture: state => state.shirts.selectedBodyMainItemTexture,
      selectedBodySideItem: state => state.shirts.selectedBodySideItem,
      selectedBodySideItemColor: state => state.shirts.selectedBodySideItemColor,
      selectedBodySideItemColor2: state => state.shirts.selectedBodySideItemColor2,
      selectedBodySideItemTexture: state => state.shirts.selectedBodySideItemTexture,
      selectedCollarItem: state => state.shirts.selectedCollarItem,
      selectedCollarItemColor: state => state.shirts.selectedCollarItemColor,
      selectedCollarItemColor2: state => state.shirts.selectedCollarItemColor2,
      selectedCollarItemColor3: state => state.shirts.selectedCollarItemColor3,
      selectedArmShoulderPartItem: state => state.shirts.selectedArmShoulderPartItem,
      selectedArmShoulderPartItemColor: state => state.shirts.selectedArmShoulderPartItemColor,
      selectedArmArmPartItem: state => state.shirts.selectedArmArmPartItem,
      selectedArmArmPartItemColor: state => state.shirts.selectedArmArmPartItemColor,
      selectedArmArmPartItemColor2: state => state.shirts.selectedArmArmPartItemColor2,
      selectedArmSleevePartItem: state => state.shirts.selectedArmSleevePartItem,
      selectedArmSleevePartItemColor: state => state.shirts.selectedArmSleevePartItemColor,
      selectedArmSleevePartItemColor2: state => state.shirts.selectedArmSleevePartItemColor2,
      selectedArmSleeveLineItem: state => state.shirts.selectedArmSleeveLineItem,
      selectedArmSleeveLineItemColor: state => state.shirts.selectedArmSleeveLineItemColor,
      selectedArmSleeveLineItemColor2: state => state.shirts.selectedArmSleeveLineItemColor2,
      selectedArmSleeveLineItemColor3: state => state.shirts.selectedArmSleeveLineItemColor3,
    }),
    currentParts: function() { 
      return this.data.parts.filter(part => part.area_id === this.selectedArea.id)
    },
    overAllItems: function() { 
      return this.data.items.overall
    },
    bodyMainItems: function() { 
      return this.data.items.body_main
    },
    bodySideItems: function() { 
      return this.data.items.body_side
    },
    collarItems: function() { 
      return this.data.items.collar
    },
    armShoulderPartItems: function() { 
      return this.data.items.arm_shoulder_part
    },
    armArmPartItems: function() { 
      return this.data.items.arm_arm_part
    },
    armSleevePartItems: function() { 
      return this.data.items.arm_sleeve_part
    },
    armSleeveLineItems: function() { 
      return this.data.items.arm_sleeve_line
    },
  },
  methods: {
    ...mapMutations({
      changeArea: 'shirts/changeArea',
      changePart: 'shirts/changePart',
      changeOverallItem: 'shirts/changeOverallItem',
      changeOverallItemSingleColor: 'shirts/changeOverallItemSingleColor',
      changeOverallItemGradationStartColor: 'shirts/changeOverallItemGradationStartColor',
      changeOverallItemGradationEndColor: 'shirts/changeOverallItemGradationEndColor',
      changeOverallItemStripeColor: 'shirts/changeOverallItemStripeColor',
      changeOverallItemTexture: 'shirts/changeOverallItemTexture',
      changeBodyMainItem: 'shirts/changeBodyMainItem',
      changeBodyMainItemColor: 'shirts/changeBodyMainItemColor',
      changeBodyMainItemTexture: 'shirts/changeBodyMainItemTexture',
      changeBodySideItem: 'shirts/changeBodySideItem',
      changeBodySideItemColor: 'shirts/changeBodySideItemColor',
      changeBodySideItemColor2: 'shirts/changeBodySideItemColor2',
      changeBodySideItemTexture: 'shirts/changeBodySideItemTexture',
      changeBodyBreastItem: 'shirts/changeBodyBreastItem',
      changeBodyBreastItemColor: 'shirts/changeBodyBreastItemColor',
      changeBodyBreastItemTexture: 'shirts/changeBodyBreastItemTexture',
      changeCollarItem: 'shirts/changeCollarItem',
      changeCollarItemColor: 'shirts/changeCollarItemColor',
      changeCollarItemColor2: 'shirts/changeCollarItemColor2',
      changeCollarItemColor3: 'shirts/changeCollarItemColor3',
      changeCollarItemTexture: 'shirts/changeCollarItemTexture',
      changeArmShoulderPartItem: 'shirts/changeArmShoulderPartItem',
      changeArmShoulderPartItemColor: 'shirts/changeArmShoulderPartItemColor',
      changeArmShoulderPartItemTexture: 'shirts/changeArmShoulderPartItemTexture',
      changeArmArmPartItem: 'shirts/changeArmArmPartItem',
      changeArmArmPartItemColor: 'shirts/changeArmArmPartItemColor',
      changeArmArmPartItemColor2: 'shirts/changeArmArmPartItemColor2',
      changeArmArmPartItemTexture: 'shirts/changeArmArmPartItemTexture',
      changeArmSleevePartItem: 'shirts/changeArmSleevePartItem',
      changeArmSleevePartItemColor: 'shirts/changeArmSleevePartItemColor',
      changeArmSleevePartItemColor2: 'shirts/changeArmSleevePartItemColor2',
      changeArmSleevePartItemTexture: 'shirts/changeArmSleevePartItemTexture',
      changeArmSleeveLineItem: 'shirts/changeArmSleeveLineItem',
      changeArmSleeveLineItemColor: 'shirts/changeArmSleeveLineItemColor',
      changeArmSleeveLineItemColor2: 'shirts/changeArmSleeveLineItemColor2',
      changeArmSleeveLineItemColor3: 'shirts/changeArmSleeveLineItemColor3',
      changeArmSleeveLineItemTexture: 'shirts/changeArmSleeveLineItemTexture',
    }),
    handleChangePart: function(part) {
      this.changePart(part)
    },
    isPartSelected: function(_part) {
      return this.selectedPart.some(part => part.id === _part.id)
    },
    isContainPartSlug: function(slug) {
      return this.selectedPart.some(part => part.slug === slug)
    },
  }
}
</script>